import { SVGProps, Ref, forwardRef } from 'react';

export const GearFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.993 1H9.007l-.75 3.008a1 1 0 0 1-1.234.722l-3.03-.828L1 9.098l2.269 2.181a1 1 0 0 1 0 1.442L1 14.902l2.993 5.196 3.03-.828a1 1 0 0 1 1.234.722L9.007 23h5.986l.75-3.008a1 1 0 0 1 1.234-.722l3.03.828L23 14.902l-2.269-2.181a1 1 0 0 1 0-1.442L23 9.099l-2.993-5.197-3.03.828a1 1 0 0 1-1.234-.722zM9.8 12c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602C9.987 13.272 9.8 12.733 9.8 12M8 12c0-2 1-4 4-4s4 2 4 4-1 4-4 4-4-2-4-4"
                fill="currentColor"
            />
        </g>
    </svg>
));
GearFilledSize24Glyph.displayName = 'GearFilledSize24Glyph';
